import { z } from 'zod';

import { chapterQuerySchema, topicQuerySchema } from '../../filters';

import { questionQuerySchema } from './question-schema';

export const assessmentSchema = z.object({
  id: z.number(),
  name: z.string(),

  course_id: z.string(),
  course_name: z.string(),
  chapters: z.array(chapterQuerySchema),
  topics: z.array(topicQuerySchema),
  category: z.array(z.string()),
  duration: z.number().nullish(),

  question_randomization: z.coerce.boolean().nullable(),
  option_randomization: z.coerce.boolean().nullable(),
  bookmark_progress: z.coerce.boolean().nullable(),

  allowed_attempts: z.coerce.number().nullable(),
  pass_percentage: z.coerce.number().or(z.literal(0)),
  total_question: z.coerce.number().nullable(),

  is_practice: z.coerce.boolean().nullish(),
  price: z.number().nullish(),
  image_url: z.string().nullish(),
  description: z.string().nullish(),

  parent: z.number().nullish(),
  is_child: z.boolean().nullish(),

  questions: z.array(questionQuerySchema),

  // assessment player
  last_attempt: z.number(),

  allowGoBack: z.boolean().nullish(),
  showFeedback: z.boolean().nullish(),
  showCorrectAnswer: z.boolean().nullish(),
  forceSubmitAnswerBeforeQuestionChange: z.boolean().nullish(),
});

export type AssessmentSchema = z.infer<typeof assessmentSchema>;
